import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Copyright from '../internals/components/Copyright';
import ChartUserByCountry from './ChartUserByCountry';
import CustomizedTreeView from './CustomizedTreeView';
import CustomizedDataGrid from './CustomizedDataGrid';
import HighlightedCard from './HighlightedCard';
import PageViewsBarChart from './PageViewsBarChart';
import SessionsChart from './SessionsChart';
import StatCard from './StatCard';
import ActorStatCard from './ActorStatCard';
import axios from "axios";
import {useEffect, useState} from "react";
import Divider from '@mui/material/Divider';
import { useGrowSetup } from '../GrowSetupContext';
import { AuthContext } from "./signin/AuthContext";
import { useContext } from "react";


const data = [
  {
    title: 'Temperatur - Produktraum',
    value: '14k',
    interval: 'Last day',
    trend: 'up',
    data: [
      200, 24, 220, 260, 240, 380, 100, 240, 280, 240, 300, 340, 320, 360, 340, 380,
      360, 400, 380, 420, 400, 640, 340, 460, 440, 480, 460, 600, 880, 920,
    ],
    measure: 'temperatur',
    ideal_value: '20', // Todo get from config
    einheit_zeichen: ' °C',
    is_actor: false,
    is_device: false,
  },
  {
    title: 'Temperatur - Tauraum',
    value: '14k',
    interval: 'Last day',
    trend: 'up',
    data: [
      200, 24, 220, 260, 240, 380, 100, 240, 280, 240, 300, 340, 320, 360, 340, 380,
      360, 400, 380, 420, 400, 640, 340, 460, 440, 480, 460, 600, 880, 920,
    ],
    measure: 'temperatur_2',
    ideal_value: '20', // Todo get from config
    einheit_zeichen: ' °C',
    is_actor: false,
    is_device: false,
  },

  {
    title: 'Luftfeuchte - Produktraum',
    value: '325',
    interval: 'Last day',
    trend: 'up',
    data: [
      1640, 1250, 970, 1130, 1050, 900, 720, 1080, 900, 450, 920, 820, 840, 600, 820,
      780, 800, 760, 380, 740, 660, 620, 840, 500, 520, 480, 400, 360, 300, 220,
    ],
    measure: 'humidity',
    ideal_value: '65', // Todo get from config
    einheit_zeichen: ' %',
    is_actor: false,
    is_device: false,
  },
  {
    title: 'Luftfeuchte - Tauraum',
    value: '14k',
    interval: 'Last day',
    trend: 'up',
    data: [
      200, 24, 220, 260, 240, 380, 100, 240, 280, 240, 300, 340, 320, 360, 340, 380,
      360, 400, 380, 420, 400, 640, 340, 460, 440, 480, 460, 600, 880, 920,
    ],
    measure: 'humidity_2',
    ideal_value: '20', // Todo get from config
    einheit_zeichen: ' %',
    is_actor: false,
    is_device: false,
  },
]

const data_actors =  [
  {
    title: 'Kühlung',
    value: '200k',
    interval: 'Last day',
    trend: 'up',
    data: [
      500, 400, 510, 530, 520, 600, 530, 520, 510, 730, 520, 510, 530, 620, 510, 530,
      520, 410, 530, 520, 610, 530, 520, 610, 530, 420, 510, 430, 520, 510,
    ],
    measure: 'heizung',
    is_actor: true,
    is_device: false,
  },
  {
    title: 'Tauphase',
    value: '200k',
    interval: 'Last day',
    trend: 'up',
    data: [
      500, 400, 510, 530, 520, 600, 530, 520, 510, 730, 520, 510, 530, 620, 510, 530,
      520, 410, 530, 520, 610, 530, 520, 610, 530, 420, 510, 430, 520, 510,
    ],
    measure: 'abluft',
    is_actor: true,
    is_device: false,
  },
  {
    title: 'Erholungsphase',
    value: '200k',
    interval: 'Last day',
    trend: 'up',
    data: [
      500, 400, 510, 530, 520, 600, 530, 520, 510, 730, 520, 510, 530, 620, 510, 530,
      520, 410, 530, 520, 610, 530, 520, 610, 530, 420, 510, 430, 520, 510,
    ],
    measure: 'umluft',
    is_actor: true,
    is_device: false,
  }]

const data_devices = [
  {
    title: 'Tau - Phase',
    value: '200k',
    interval: 'Last day',
    trend: 'up',
    data: [
      500, 400, 510, 530, 520, 600, 530, 520, 510, 730, 520, 510, 530, 620, 510, 530,
      520, 410, 530, 520, 610, 530, 520, 610, 530, 420, 510, 430, 520, 510,
    ],
    einheit_zeichen: '',
    measure: 'bme',
    is_actor: false,
    is_device: true,
  },
  {
    title: 'Erholungsphase',
    value: '200k',
    interval: 'Last day',
    trend: 'up',
    data: [
      500, 400, 510, 530, 520, 600, 530, 520, 510, 730, 520, 510, 530, 620, 510, 530,
      520, 410, 530, 520, 610, 530, 520, 610, 530, 420, 510, 430, 520, 510,
    ],
    measure: 'sht',
    einheit_zeichen: '',
    is_actor: false,
    is_device: true,
  },
];

function isNowBetween(startStr, endStr) {
  if(!startStr || ! endStr)
  return true;
  const [sh, sm] = startStr.split(':').map(Number);
  const [eh, em] = endStr.split(':').map(Number);

  const now = new Date();
  const start = new Date(now);
  start.setHours(sh, sm, 0, 0);
  const end = new Date(now);
  end.setHours(eh, em, 0, 0);

  if (start <= end) {
    // Normalfall, z.B. 09:00–17:00
    return now >= start && now <= end;
  } else {
    // Über Mitternacht, z.B. 22:00–06:00
    // Dann ist es zwischen start und 23:59 oder zwischen 00:00 und end
    return now >= start || now <= end;
  }
}

export default function MainGrid_Curator(props) {
    const [gauge_values, setGauge] = useState([]);
    const { grow_setup, setGrowSetup } = useGrowSetup();
    const { token } = useContext(AuthContext);
    
    

    const  fetchData = async () =>{
    var data = []
    var yesterday = new Date();
    yesterday =  new Date(yesterday.setDate(yesterday.getDate() -1));
    var today = new Date();
      try {
        axios.post('/get_current_gauge_values/'+grow_setup,{hello:"world"},{
          headers: {'Access-Control-Allow-Origin': '*',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
            'Method': 'GET',
          },
        }).then(result => {
              setGauge(result.data);

              //this.state.layout = this.generateLayout(result);
            })
            .catch(error => {
              console.error('Error fetching data:', error);
            });

      } catch (error) {
        console.error(error);
      }
    };

  useEffect(() => {

    fetchData();
    const interval = setInterval(fetchData, 10000);

    return () => clearInterval(interval);
  }, [grow_setup]);






  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Overview
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {data.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard {...card} gauge_value={gauge_values[card.measure]} message_high = {card.message_to_high} message_low = {card.message_to_low} ideal_val = {card.ideal_value} einheit_zeichen = {card.einheit_zeichen}  grow_setup={grow_setup} />
          </Grid>

        ))}



      </Grid>

      <Grid
          container
          spacing={2}
          columns={12}
          sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {data_actors.map((card, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
              <ActorStatCard {...card} gauge_value={gauge_values[card.measure]}  grow_setup={grow_setup} />
            </Grid>
        ))}



      </Grid>

      <Grid
          container
          spacing={2}
          columns={12}
          sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {data_devices.map((card, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
                  <StatCard {...card} gauge_value={gauge_values[card.measure]} title={card.measure}  grow_setup={grow_setup} />
            </Grid>

        ))}



      </Grid>

      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}
